import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {getPortalUserDetails } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const portalUserService = createAsyncThunk(
    'fetch/portal-user', getPortalUserDetails
)

const initialState = {
    jwtToken: "",
    loader: false
}

const portalUserSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {
        resetPortalUser: (state) => {
            state.jwtToken = ""
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(portalUserService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(portalUserService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(portalUserService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetPortalUser } = portalUserSlice.actions

export default portalUserSlice.reducer